import FleetAssignment from '@src/main/modules/parameters/ui/fleet-assignment/components/FleetAssignment';

const FleetAssignmentPage = () => <FleetAssignment />;

export default FleetAssignmentPage;
